<template>
    <b-overlay :show="loading">
        <b-container fluid>
            <b-row align-h="center">
                <b-col cols="12" lg="8">

                    <b-alert v-if="error" show variant="danger" class="mt-2">
                        {{errorMsg}}
                        <!-- TBD error component. -->
                    </b-alert>

                    <!-- LIVE WEBINARS -->
                    <div class="div-section-header">
                      <b-row>
                        <b-col cols="12">
                          <div>
                            <span class="txt-section-title">Cancel Seat</span>
                          </div>
                        </b-col>
                      </b-row>
                    </div>

                    <b-card v-if="classObj.classId !== 0" class="text-center mt-3 mb-3" style="background-color: #FFD;">
                        <b-overlay :show="busy" rounded="sm">
                            <b-button variant="danger" @click="cancelSeat">I Cannot Attend</b-button>
                        </b-overlay>
                        <div class="mt-2 text-left">
                            If you are unable to attend this live online presentation please click the red button.
                            Doing so will allow your seat to be assigned to someone on the waiting list for this class.
                        </div>
                    </b-card>

                    <div class="div-section-body">
                    <b-row class="pt-2">
                        <b-col cols="4">
                            <b-img fluid v-bind:src="classObj.photo" />
                        </b-col>
                        <b-col cols="8" style="margin-left: -20px;">
                            <div class="class-title">{{classObj.className}}</div>
                            <div class="class-details">
                                {{classObj.name}}
                                <br />
                                Sponsor: {{classObj.companyName}}
                                <br>
                                {{classObj.credits}} CEU (Live, Interactive)
                                <br />
                                <span class="red">{{classObj.releaseDate | prettyDateTime}}</span>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="pb-3" style="padding: 0px 3px 10px 3px;">
                        <!-- :inner-html.prop instead of v-html -->
                        <b-col class="mt-2" :inner-html.prop="this.classObj.description | nl2br"></b-col>
                    </b-row>
                  </div>

                </b-col>
            </b-row>
        </b-container>
    </b-overlay>
</template>

<script>
/* eslint-disable */
'use strict'

import service from "@/service/service";
import utils from "@/utils/utils";

var data = {
  debug: false,
  error: false,
  errorMsg: null,
  loading: true,
  busy: false,
  msg: "Cancel Seat",
  blurb: "Cancel Seat.",
  classObj: { status: false},
  studentHash: "",
  classHash: "",
  cancelCode: ""
}

export default {
  name: "CancelSeat",
  data() {
    return data;
  },
  props: {
    // route set to use props mapped to url parameters
    code: {
      type: String,
      required: true,
      default: ""
    }
  },
  computed: {
    btnWebinarDisabled() {
      return (this.classObj.zoomCode === null)
    },
    btnWebinarVariant() {
      return (this.classObj.zoomCode !== null) ? 'success' : 'secondary'
    },
    btnExamDisabled() {
      return (this.classObj.zoomCode === null)
    },
    btnExamVariant() {
      return (this.classObj.zoomCode !== null) ? 'secondary' : 'secondary'
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    cancelSeat() {
      // console.log(`Cancel Seat: ${this.cancelCode}`)
      if (!window.confirm('Please confirm your intent to release your seat.')) return;
      this.busy = true
      service
        .cancelSeat(this.cancelCode, this.studentHash)
        .then(
          (res => {
            console.log(`back from cancelSeat!`)
            if (this.debug) console.log(res)
            if (res.status) {
                // proceed to webinars
                this.$router.push('/webinars')
            }
            else {
                console.log(`Error on return from cancelSeat. ${res.status}`)
                this.error = true
                this.errorMsg = res.errorMsg || 'Unable to cancel seat.  Unknown reason.'
            }
          }).bind(this)
        )
        .finally(e => {
          this.busy = false
          console.log(`finally...`)
        })
        .catch(e => {
          this.error = true
          console.log(e);
        })
    }
  },
  created() {
    this.cancelCode = this.code || this.$route.query.code || ''
    this.studentHash = this.$root.getToken()
    if (this.cancelCode) {
      service
        .getCancelSeat(this.cancelCode, this.studentHash)
        .then(
          (res => {
            if (this.debug) console.log(`back from getCancelSeat!`)
            if (this.debug) console.log(data)
            if (res.status) {
              this.classObj = res.data[0]
            }
            else {
              this.error = true
            }
          }).bind(this)
        )
        .finally(e => {
          this.loading = false;
          if (this.debug) console.log(`finally...`)
        })
        .catch(e => {
          this.error = true
          console.log(e)
        });
    }
    else {
      this.$router.push("/exams")
    }
    // this.error = this.$root.getClassId() === 0;
  },
  mounted () {
    if (this.debug) console.log('mounted')
  },
  beforeDestroy() {
    this.classObj = {status: false, zoomCode: null}
    this.studentData = {status: false}
    this.error = false
    this.loading = true
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CancelSeat.vue